import { Box, Paper, Typography, TextField, Button, Chip, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const MainWrapper = styled(Box)({
  padding: "24px",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
  minHeight: "100%",

  "@media (max-width: 768px)": {
    padding: "16px",
  },
});

export const HeaderSection = styled(Box)({
  marginBottom: "24px",
});

export const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  color: "#1e293b",
  letterSpacing: "-0.5px",
  fontSize: "1.5rem",
});

export const HeaderSubtitle = styled(Typography)({
  color: "#64748b",
  fontSize: "0.875rem",
});

export const HeaderChip = styled(Chip)({
  fontWeight: 600,
  fontSize: "0.75rem",
  backgroundColor: colors.primaryLight,
  color: colors.primary,
  borderRadius: "6px",
});

export const CardPaper = styled(Paper)({
  padding: "24px",
  height: "100%",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

export const IconBox = styled(Box)({
  width: 42,
  height: 42,
  borderRadius: "10px",
  backgroundColor: colors.primaryLight,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: colors.primary,
});

export const CardTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: "1.1rem",
  color: "#1e293b",
});

export const CardSubtitle = styled(Typography)({
  color: "#64748b",
  fontSize: "0.825rem",
});

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontSize: "0.875rem",
    backgroundColor: "#ffffff",
    "&:hover fieldset": { borderColor: colors.primary },
    "&.Mui-focused fieldset": { borderColor: colors.primary, borderWidth: "1.5px" },
  },
});

export const SubmitButton = styled(Button)({
  height: "42px",
  borderRadius: "10px",
  backgroundColor: colors.primary,
  textTransform: "none",
  color: "#fff",
  fontWeight: 600,
  fontSize: "0.875rem",
  boxShadow: `0 4px 12px ${colors.primary}33`,
  "&:hover": { backgroundColor: colors.primaryHover },
});

export const CompanyListPaper = styled(Paper)({
  padding: "20px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
});

export const CompanyChipItem = styled(Chip)({
  borderRadius: "8px",
  fontWeight: 500,
  fontSize: "0.825rem",
  borderColor: "#cbd5e1",
  backgroundColor: "#f8fafc",
  color: "#334155",
});
